@let member = member$ | async;
<div class="controls">
  <!-- @if (member) {
    <a [routerLink]="ordersUrl">Se ordrehistorik</a>
  } -->
  @if (!member) {
    <button class="unstyled-button login" (click)="openLoginDialog()">
      <span>{{ loginButton }}</span>
      <mat-icon aria-hidden="true" svgIcon="lock_open"></mat-icon>
    </button>
  }
  @if (member) {
    <button class="unstyled-button logout" (click)="logout()">
      <span>{{ logoutButton }}</span>
      <mat-icon aria-hidden="true" svgIcon="lock"></mat-icon>
    </button>
  }
</div>

@if (member) {
  <div class="logged-in">Logget ind som: {{ member.userName }}</div>
}
